/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptions, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncher.js.map